module.exports = __webpack_public_path__ + "static/wanted-banner-compressed-176a09f299bdae080a12ac8603090ea6.png";